export class ErrorBoundaryError extends Error {
  public constructor(error: Error) {
    super(error.message)

    this.cause = error
    this.name = 'ErrorBoundaryError'
    this.stack = error.stack
  }
}
